import { getError } from '@/utils/helpers';
import OrganisationService from '@/services/OrganisationService';

export const namespaced = true;

function setPaginatedOrganisations(commit, response) {
  commit('SET_ORGANISATIONS', response.data.data);
  commit('SET_META', response.data.meta);
  commit('SET_LINKS', response.data.links);
  setSuccess(commit);
}

function setOrganisation(commit, response) {
  const data = response.data.data;
  if (data.street_address == null) {
    data.street_address = { street: '', suburb: null };
  }
  if (data.postal_address == null) {
    data.postal_address = { street: '', suburb: null };
  }
  commit('SET_ORGANISATION', response.data.data);
  commit('SET_META', response.data.meta);
  setSuccess(commit);
}

function setSuccess(commit) {
  commit('SET_LOADING', false);
  commit('SET_SUCCESS', true);
}

function setMessage(dispatch, message) {
  dispatch('ui/snackbarSuccess', message, { root: true });
}

function setError(dispatch, commit, error) {
  commit('SET_LOADING', false);
  commit('SET_SUCCESS', false);
  commit('SET_ERROR', error);
  dispatch('ui/snackbarError', error, { root: true });
}

export const state = {
  organisations: [],
  organisation: {},
  meta: null,
  links: null,
  loading: false,
  error: null,
  success: null
};

export const mutations = {
  SET_ORGANISATIONS(state, organisations) {
    state.organisations = organisations;
  },
  SET_ORGANISATION(state, organisation) {
    state.organisation = organisation;
  },
  SET_META(state, meta) {
    state.meta = meta;
  },
  SET_LINKS(state, links) {
    state.links = links;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_SUCCESS(state, success) {
    state.success = success;
  }
};

export const actions = {
  searchOrganisations({ dispatch, commit }, options) {
    commit('SET_LOADING', true);
    OrganisationService.search(options)
      .then(response => {
        setPaginatedOrganisations(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  list({ dispatch, commit }, options) {
    commit('SET_LOADING', true);
    OrganisationService.list(options)
      .then(response => {
        setPaginatedOrganisations(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  get({ dispatch, commit }, id) {
    commit('SET_LOADING', true);
    OrganisationService.get(id)
      .then(response => {
        setOrganisation(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  async save({ dispatch, commit }, data) {
    commit('SET_LOADING', true);
    return OrganisationService.save(data.id, data.organisation)
      .then(response => {
        setOrganisation(commit, response);
        setMessage(dispatch, 'Saved organisation');
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  async delete({ dispatch, commit }, id) {
    commit('SET_LOADING', true);
    return OrganisationService.delete(id)
      .then(() => {
        setSuccess(commit);
        setMessage(dispatch, 'Deleted organisation');
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  paginate({ dispatch, commit }, link) {
    commit('SET_LOADING', true);
    OrganisationService.paginate(link)
      .then(response => {
        setPaginatedOrganisations(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  }
};

export const getters = {
  organisations: state => {
    return state.organisations;
  },
  organisation: state => {
    return state.organisation;
  },
  meta: state => {
    return state.meta;
  },
  links: state => {
    return state.links;
  },
  loading: state => {
    return state.loading;
  },
  error: state => {
    return state.error;
  },
  success: state => {
    return state.success;
  }
};
